import React from "react";
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components/macro";
import { DisplayWithIcon } from "../shared/Typography/types";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { themePalette } from "../../theme";
import {
  TestResultsCfcAction,
  TestResultsCfcContainer,
  TestResultsCfcStatus,
  TestResultsCfcTitle,
  TestResultIconAndTypography,
  TestResultsIcon,
} from "./TestResults.styles";

const CfcDashboardIcon = styled(TestResultsIcon)`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 25px;

  svg {
    height: 24px;
    width: 24px;
  }
`;

export const TestResultsCfcInfo = (
  displayWithIcon: DisplayWithIcon,
  action?: React.ReactNode,
  showReportStatus?: boolean,
  seeReportLabel = "See Report",
): React.ReactElement => (
  <TestResultsCfcContainer>
    <TestResultsCfcTitle>
      {GetTypographyContent({
        content: "Unity Confirm™",
        size: "large",
        textColor: "greyMedium",
        isBold: true,
        isCaps: true,
      })}
    </TestResultsCfcTitle>
    <TestResultsCfcStatus>
      <TestResultIconAndTypography>
        <CfcDashboardIcon>
          {showReportStatus ? (
            <FontAwesomeIcon
              aria-hidden
              icon={faEyeSlash}
              style={{ color: themePalette.greyMedium }}
            />
          ) : (
            displayWithIcon.icon
          )}
        </CfcDashboardIcon>
        {GetTypographyContent({
          content: showReportStatus ? seeReportLabel : displayWithIcon.display,
          size: "medium",
          textColor: "greyMedium",
        })}
      </TestResultIconAndTypography>
    </TestResultsCfcStatus>
    {action && <TestResultsCfcAction>{action}</TestResultsCfcAction>}
  </TestResultsCfcContainer>
);
